import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-rectify-defect-stepper',
  templateUrl: './rectify-defect-stepper.component.html',
  styleUrls: ['./rectify-defect-stepper.component.scss'],
  standalone: false
})
export class RectifyDefectStepperComponent implements OnInit {
  @Input() currentStep: number = 1;
  @Input() step2SubtitleKey: string = 'RECTIFY_STEPPER_CIRCLE_6'; 
  @Input() showStep3: boolean = true; 

  constructor() { }

  ngOnInit() { }
}
